import { Asset } from "expo-asset";
import { Image } from "react-native";

const loadAssets = async () => {
  const cacheImages = (images) => {
    return images.map((image) => {
      if (typeof image === "string") {
        return Image.prefetch(image);
      } else {
        return Asset.fromModule(image).downloadAsync();
      }
    });
  };

  let images = [
    require("../assets/spinner.png"),
    require("../assets/header.png"),
    require("../assets/background/clear.jpeg"),
    require("../assets/background/clouds.jpeg"),
    require("../assets/background/drizzle.jpeg"),
    require("../assets/background/dust.jpeg"),
    require("../assets/background/extreme.jpeg"),
    require("../assets/background/fog.jpeg"),
    require("../assets/background/haze.jpeg"),
    require("../assets/background/mist.jpeg"),
    require("../assets/background/rain.jpeg"),
    require("../assets/background/smoke.jpeg"),
    require("../assets/background/snow.jpeg"),
    require("../assets/background/squall.jpeg"),
    require("../assets/background/thunderstorm.jpeg"),
  ];

  const imageAssets = cacheImages(images);

  await Promise.all(imageAssets);
};

export default loadAssets;
